import useClickToCopy from '@/hooks/useClickToCopy'
import { usePathname } from 'next/navigation'
import LinkAngledIcon from './LinkAngledIcon'
import { getCurrentBaseUrl } from '@/utils/routes/client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons'

export default function SocialShare({ className }: { className?: string }) {
	const pathname = usePathname()
	const [copyStatus, copy] = useClickToCopy(
		typeof window !== 'undefined' ? window.location.href : ''
	)

	/* Share to Twitter/X, LinkedIn, Facebook, or copy link */
	return (
		<div className={className}>
			<span className="text-sm">SHARE</span>

			<div className="flex items-center gap-3 [&>a]:text-contrast-low hover:[&>a]:text-blue-dark mt-3 [&>a]:transition-colors [&>a]:duration-300">
				<a
					rel="me noreferrer"
					target="_blank"
					href={`https://www.facebook.com/sharer/sharer.php?u=${getCurrentBaseUrl()}${pathname}`}
					aria-label="Share on Facebook"
				>
					<FontAwesomeIcon icon={faFacebook} className="p-1" />
				</a>
				<a
					rel="me noreferrer"
					target="_blank"
					href={`https://www.linkedin.com/sharing/share-offsite/?url=${getCurrentBaseUrl()}${pathname}`}
					aria-label="Share on LinkedIn"
				>
					<FontAwesomeIcon icon={faLinkedin} className="p-1" />
				</a>
				<a
					rel="me noreferrer"
					target="_blank"
					href={`https://x.com/intent/tweet?via=Cottrell&url=${getCurrentBaseUrl()}${pathname}`}
					aria-label="Share on X"
				>
					<FontAwesomeIcon icon={faXTwitter} className="p-1" />
				</a>
				<button
					onClick={copy}
					className="transition-colors duration-300 text-contrast-low hover:text-blue-dark"
					aria-label="Copy link"
				>
					{copyStatus ? (
						<span className="font-paragraph-size-300-medium">Copied!</span>
					) : (
						<LinkAngledIcon className="-translate-y-[2px] pb-px" />
					)}
				</button>
			</div>
		</div>
	)
}
